module.exports = __webpack_public_path__ + "static/img/logo_086.09602fc0.png";